/**
 * @typedef {import('synapse-common-device-service').Device} Device
 */

export const DEVICE_VERIFIED = 'deviceVerified';
export const DEVICE_GROUP_MEMBERSHIP_CHANGED = 'deviceGroupMembershipChanged';
export const DEVICE_UPDATED = 'deviceUpdated';
export const DEVICE_ADDED = 'addDevice';
export const DEVICE_DELETED = 'deleteDevice';

/**
 *
 * @param {Device} recentDevice
 * @param {Device} previousDevice
 */
export const deviceMessageTypeCalculator = (messageType, recentDevice, previousDevice) => {
  if (messageType === DEVICE_ADDED) {
    return DEVICE_ADDED;
  }

  if (messageType === DEVICE_DELETED) {
    return DEVICE_DELETED;
  }

  if (recentDevice.verified === true && previousDevice.verified === false) {
    return DEVICE_VERIFIED;
  }

  if (recentDevice.deviceGroupId !== previousDevice?.deviceGroupId) {
    return DEVICE_GROUP_MEMBERSHIP_CHANGED;
  }

  return DEVICE_UPDATED;
};
